export default "__VITE_ASSET__DH0fL0Be__"